import { render, staticRenderFns } from "./ManageLicences.vue?vue&type=template&id=a57e3d2a&"
import script from "./ManageLicences.vue?vue&type=script&lang=js&"
export * from "./ManageLicences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports